import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import Box, { BoxProps } from '../Box';
import Button, { Props as ButtonProps } from '../Button';
import { styled } from '../styles';
import Typography from '../Typography';
export type SeeMoreProps = {
  isLoading?: boolean;
  shouldHideButton?: boolean;
  shouldShowResultCount?: boolean;
  rootComponent?: ElementType;
  onClick?: () => void;
  translations?: {
    seeMore: string;
    totalResults: string;
  };
  buttonProps?: ButtonProps;
};
const Root = styled(Box)<BoxProps<ElementType>>(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  paddingBottom: 0,
  width: '100%',
  minWidth: 250
}));
function SeeMore(t0) {
  const $ = _c(17);
  const {
    isLoading: t1,
    shouldHideButton: t2,
    rootComponent: t3,
    shouldShowResultCount: t4,
    onClick,
    translations: t5,
    buttonProps: t6
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const shouldHideButton = t2 === undefined ? false : t2;
  const RootComponent = t3 === undefined ? "div" : t3;
  const shouldShowResultCount = t4 === undefined ? false : t4;
  let t7;
  if ($[0] !== t5) {
    t7 = t5 === undefined ? {
      seeMore: "See more",
      totalResults: "X out of Y"
    } : t5;
    $[0] = t5;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const translations = t7;
  let t8;
  if ($[2] !== t6) {
    t8 = t6 === undefined ? {} : t6;
    $[2] = t6;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const buttonProps = t8;
  let t9;
  if ($[4] !== buttonProps || $[5] !== isLoading || $[6] !== onClick || $[7] !== shouldHideButton || $[8] !== translations) {
    t9 = (isLoading || !shouldHideButton) && <Button onClick={onClick} variant="tertiary" isLoading={isLoading} {...buttonProps}>{translations.seeMore}</Button>;
    $[4] = buttonProps;
    $[5] = isLoading;
    $[6] = onClick;
    $[7] = shouldHideButton;
    $[8] = translations;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== shouldShowResultCount || $[11] !== translations) {
    t10 = shouldShowResultCount && <Typography sx={{
      marginLeft: "auto"
    }} variant="bodySmall">{translations.totalResults}</Typography>;
    $[10] = shouldShowResultCount;
    $[11] = translations;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== RootComponent || $[14] !== t10 || $[15] !== t9) {
    t11 = <Root component={RootComponent}>{t9}{t10}</Root>;
    $[13] = RootComponent;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
export default SeeMore;